'use client';
import { jsx } from 'react/jsx-runtime';
import { splitProps } from '@chakra-ui/utils';
import { cx } from '@chakra-ui/utils/cx';
import { RadioThemingContextProvider, RadioGroupContextProvider } from './radio-group-context.mjs';
import { splitRadioGroupProps } from './radio-group-props.mjs';
import { useRadioGroup } from './use-radio-group.mjs';
import { forwardRef } from '../system/forward-ref.mjs';
import { chakra } from '../system/factory.mjs';

const RadioGroupRoot = forwardRef(
  function RadioGroupRoot2(props, ref) {
    const [themingProps, restProps] = splitProps(props, [
      "variant",
      "size",
      "colorScheme"
    ]);
    const [groupProps, localProps] = splitRadioGroupProps(restProps);
    const api = useRadioGroup(groupProps);
    return /* @__PURE__ */ jsx(RadioThemingContextProvider, { value: themingProps, children: /* @__PURE__ */ jsx(RadioGroupContextProvider, { value: api, children: /* @__PURE__ */ jsx(
      chakra.div,
      {
        ...api.getRootProps(localProps, ref),
        className: cx("chakra-radio-group", localProps.className)
      }
    ) }) });
  }
);
RadioGroupRoot.displayName = "RadioGroupRoot";

export { RadioGroupRoot };
